/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rich_Bright_Elk_GlowInputs */

const en_rich_bright_elk_glow = /** @type {(inputs: Rich_Bright_Elk_GlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter email...`)
};

const de_rich_bright_elk_glow = /** @type {(inputs: Rich_Bright_Elk_GlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail eingeben...`)
};

/**
* | output |
* | --- |
* | "Enter email..." |
*
* @param {Rich_Bright_Elk_GlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rich_bright_elk_glow = /** @type {((inputs?: Rich_Bright_Elk_GlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rich_Bright_Elk_GlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rich_bright_elk_glow(inputs)
	return de_rich_bright_elk_glow(inputs)
});